import axios from "axios";
import {
  PRODUCT_REQUIREMENT_LIST_REQUEST,
  PRODUCT_REQUIREMENT_LIST_SUCCESS,
  PRODUCT_REQUIREMENT_LIST_FAIL,
  PRODUCT_REQUIREMENT_SINGLE_REQUEST,
  PRODUCT_REQUIREMENT_SINGLE_SUCCESS,
  PRODUCT_REQUIREMENT_SINGLE_FAIL,
  CREATE_PRODUCT_REQUIREMENT_REQUEST,
  CREATE_PRODUCT_REQUIREMENT_SUCCESS,
  CREATE_PRODUCT_REQUIREMENT_FAIL,
  UPDATE_PRODUCT_REQUIREMENT_REQUEST,
  UPDATE_PRODUCT_REQUIREMENT_SUCCESS,
  UPDATE_PRODUCT_REQUIREMENT_FAIL,
  DELETE_PRODUCT_REQUIREMENT_REQUEST,
  DELETE_PRODUCT_REQUIREMENT_SUCCESS,
  DELETE_PRODUCT_REQUIREMENT_FAIL,
} from "constants/productRequirementConstants";
import { REACT_APP_API_URL } from "constants/apiConstants";
import { getProductList, getSingleProduct } from "actions/productActions";
import ProductRequirementsService from "services/product-requirements-service";

export const getProductRequirementsList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_REQUIREMENT_LIST_REQUEST,
    });

    const res = await ProductRequirementsService.getProductRequirements();
    console.log(
      "🚀 ~ file: productRequirementActions.js:30 ~ getProductRequirementsList ~ res:",
      res
    );

    dispatch({
      type: PRODUCT_REQUIREMENT_LIST_SUCCESS,
      payload: res.foundProductRequirements,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: productRequirementActions.js:37 ~ getProductRequirementsList ~ error:",
      error
    );
    dispatch({
      type: PRODUCT_REQUIREMENT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getProductRequirementsSingle =
  (productRequirementId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PRODUCT_REQUIREMENT_SINGLE_REQUEST,
      });

      const res = await ProductRequirementsService.getSingleProductRequirements(
        productRequirementId
      );
      console.log("🚀 ~ file: productRequirementActions.js:56 ~ res:", res);

      dispatch({
        type: PRODUCT_REQUIREMENT_SINGLE_SUCCESS,
        payload: res.foundProductRequirement,
      });
    } catch (error) {
      console.log("🚀 ~ file: productRequirementActions.js:63 ~ error:", error);
      dispatch({
        type: PRODUCT_REQUIREMENT_SINGLE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const createNewProductRequirement =
  (productRequirement) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_PRODUCT_REQUIREMENT_REQUEST,
      });

      const res = await ProductRequirementsService.createProductRequirements(
        productRequirement
      );
      dispatch(getProductList());
      dispatch(getSingleProduct(productRequirement.product));

      dispatch({
        type: CREATE_PRODUCT_REQUIREMENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: productRequirementActions.js:92 ~ error:", error);
      dispatch({
        type: CREATE_PRODUCT_REQUIREMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const productRequirementUpdating =
  (productRequirementId, productRequirement) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_PRODUCT_REQUIREMENT_REQUEST,
      });

      const res = await ProductRequirementsService.editProductRequirements(
        productRequirementId,
        productRequirement
      );
      console.log("🚀 ~ file: productRequirementActions.js:114 ~ res:", res);

      dispatch(getProductList());
      dispatch(getSingleProduct(productRequirement.product));

      dispatch({
        type: UPDATE_PRODUCT_REQUIREMENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: productRequirementActions.js:124 ~ error:",
        error
      );
      dispatch({
        type: UPDATE_PRODUCT_REQUIREMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const productRequirementDeleting =
  (productRequirementId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: DELETE_PRODUCT_REQUIREMENT_REQUEST,
      });

      const res = await axios.delete(
        `${REACT_APP_API_URL}/admin/services/${productRequirementId}`
      );

      dispatch({
        type: DELETE_PRODUCT_REQUIREMENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      dispatch({
        type: DELETE_PRODUCT_REQUIREMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };
